export const cities = [
  { label: 'Karachi', value: 'karachi' },
  { label: 'Islamabad', value: 'islamabad' },
  { label: 'Lahore', value: 'lahore' },
  { label: 'Mandi Bahauddin', value: 'mandi-bahauddin' },
  { label: "Peshawar", value: "peshawar" },
]
